import SvgIcon from '@material-ui/core/SvgIcon'
import React from 'react'

export const Drug = props => (
  <SvgIcon {...props}>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Drug" fill="currentcolor" fillRule="nonzero">
        <g id="baseline-spellcheck-24px">
          <path
            d="M 22.132812 1.851562 C 19.667969 -0.617188 15.652344 -0.617188 13.183594 1.851562 L 7.964844 7.070312 L 13.890625 12.992188 C 15.109375 11.976562 16.65625 11.34375 18.363281 11.34375 C 19.339844 11.34375 20.273438 11.546875 21.121094 11.910156 L 22.132812 10.800781 C 24.601562 8.332031 24.601562 4.316406 22.132812 1.851562 Z M 22.132812 1.851562"
            id="Shape"
          />
          <path
            d="M 12.902344 13.996094 L 6.96875 8.0625 L 1.863281 13.175781 C -0.605469 15.644531 -0.605469 19.65625 1.863281 22.125 C 4.332031 24.59375 8.394531 24.640625 10.859375 22.171875 L 11.894531 21.132812 C 11.53125 20.285156 11.328125 19.351562 11.328125 18.375 C 11.328125 16.710938 11.933594 15.199219 12.902344 13.996094 Z M 12.902344 13.996094"
            id="Shape2"
          />
          <path
            d="M 12.734375 18.375 C 12.734375 21.242188 14.886719 23.578125 17.660156 23.929688 L 17.660156 12.820312 C 14.886719 13.167969 12.734375 15.507812 12.734375 18.375 Z M 12.734375 18.375"
            id="Shape3"
          />
          <path
            d="M 19.066406 12.820312 L 19.066406 23.929688 C 21.835938 23.578125 23.988281 21.242188 23.988281 18.375 C 23.988281 15.507812 21.835938 13.167969 19.066406 12.820312 Z M 19.066406 12.820312"
            id="Shape4"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
)

export default Drug



// WEBPACK FOOTER //
// ./src/icons/Drug.js